module.exports = __webpack_public_path__ + "static/media/logo_transparent_cut_for_dark.6c5a7a4c.png";